export const REQUEST_INSTALLER_DETAILS =
	"REQUEST_INSTALLER_DETAILS";
export const RECEIVE_INSTALLER_DETAILS =
	"RECEIVE_INSTALLER_DETAILS";
export const REQUEST_POST_CONTACT_DATA =
	"REQUEST_POST_CONTACT_DATA";
export const RECEIVE_POST_CONTACT_DATA =
	"RECEIVE_POST_CONTACT_DATA"